<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">Notification</h3>
		</div>
	</div>
	<div class="kt-portlet__body">

		<mat-tab-group (selectedTabChange)="onTabChange($event)">
			<mat-tab label="Machine Alerts">
				<div style="min-height: 40vh;">
					<h5>Errors</h5>
					<div class="row ml-3">
						<mat-checkbox class="mt-3 mb-3 col-xl-3 col-md-4 col-sm-6" (change)="checkBoxClicked()" *ngFor="let topic of topics.errors" [(ngModel)]="topic.checked">{{topic.log_msg}}</mat-checkbox>
					</div>
					<hr>
					<h5>Warnings</h5>
					<div class="row ml-3">
						<mat-checkbox class="mt-3 mb-3 col-xl-3 col-md-4 col-sm-6" *ngFor="let topic of topics.warnings" (change)="checkBoxClicked()" [(ngModel)]="topic.checked">{{topic.log_msg}}</mat-checkbox>
					</div>
				</div>
				<div class="row mt-1 mb-1">
					<button class="text-left ml-3 mt-3" (click)="clearAll()" [disabled]="!unSubs" mat-raised-button color="basic">Clear Selections</button>
					<button class="ml-auto text-right mt-3" [disabled]="!subs" (click)="unSubscribe()" mat-raised-button color="warn">Unsubscribe all</button>
					<button class="ml-3 mr-3 mt-3" (click)="subscribe()" [disabled]="!unSubs" mat-raised-button color="accent">{{btnTxt()}}</button>
				</div>
			</mat-tab>
			<mat-tab label="Subscriptions">
				<div style="min-height: 40vh;" class="ml-3 mt-3 subscriptions-content">
					<!-- Loading State -->
					<div *ngIf="loadingSubscriptions" class="text-center">
						<mat-spinner diameter="40"></mat-spinner>
					</div>

					<!-- Content -->
					<div *ngIf="!loadingSubscriptions">
						<!-- Analytics Reports Subscription -->
						<div class="subscription-section mb-5">
							<div class="subscription-header">
								<mat-checkbox
									[(ngModel)]="analyticsSubscribed"
									(change)="onAnalyticsChange()"
									class="subscription-checkbox">
									<span class="subscription-title">Analytics reports</span>
								</mat-checkbox>
								<div class="subscription-description">
									Weekly summary of usage, sales, and trends.
								</div>
							</div>

							<!-- Distributor Selection (Superadmin only) -->
							<div *ngIf="role === 'sadmin' && analyticsSubscribed" class="subscription-config mt-4">
								<div class="config-section">
									<div class="config-label mb-2">Select distributors:</div>

									<!-- Distributor Multi-Select - Styled like campus selection -->
									<div class="distributor-select-row">
										<div class="scope-select-wrapper">
											<label class="scope-select-label">Distributors</label>
											<kt-searchable-select
												[options]="distributorSelectOptions"
												placeholder="Select distributors..."
												searchPlaceholder="Search distributors..."
												[ngModel]="distributorDropdownValue"
												(immediateSelectionChange)="onDistributorImmediateSelect($event)"
												(selectionChange)="onDistributorSelectChange($event)"
												[disabled]="loadingDistributors || !analyticsSubscribed"
												[multiple]="false"
												[clearOnSelect]="true">
											</kt-searchable-select>
										</div>

										<!-- Selected Distributor Chips - Positioned to the right of dropdown -->
										<div *ngIf="selectedDistributorIds.length > 0" class="distributor-chips-container">
											<mat-chip-list>
												<mat-chip
													*ngFor="let distributorId of selectedDistributorIds"
													color="primary">
													{{ getDistributorName(distributorId) }}
													<mat-icon matChipRemove (click)="removeDistributor(distributorId); $event.stopPropagation()">cancel</mat-icon>
												</mat-chip>
											</mat-chip-list>
										</div>
									</div>

									<div class="mt-2">
										<span class="text-muted" style="font-size: 0.75rem;">You will receive analytics emails for the selected distributors.</span>
									</div>
								</div>
							</div>
						</div>

						<hr class="mb-5">

						<!-- Stockout Alerts Subscription -->
						<div class="subscription-section mb-5">
							<div class="subscription-header">
								<mat-checkbox
									[(ngModel)]="stockoutSubscribed"
									(change)="onStockoutChange()"
									class="subscription-checkbox">
									<span class="subscription-title">Stockout alerts</span>
								</mat-checkbox>
								<div class="subscription-description">
									Alerts when machines are at risk of running out of products.
								</div>
							</div>

							<!-- Stockout Configuration (only if stockoutSubscribed is true) -->
							<div *ngIf="stockoutSubscribed" class="subscription-config">
								<!-- Alert Type Selection -->
								<div class="config-section mb-4">
									<div class="config-label mb-3">Alert type:</div>
									<mat-radio-group [(ngModel)]="stockoutMode" (change)="onStockoutModeChange()" class="alert-type-group">
										<!-- Daily Option -->
										<div class="alert-option-block mb-3">
											<mat-radio-button value="daily" class="alert-option-radio">
												<div class="alert-option-content">
													<div class="alert-option-label">Daily</div>
													<div class="alert-option-description">Get a daily digest of all machines in the selected campuses, their inventory levels and when they are projected to run out of inventory.</div>
												</div>
											</mat-radio-button>
										</div>

										<!-- On-Demand Option -->
										<div class="alert-option-block mb-3">
											<mat-radio-button value="on-demand" class="alert-option-radio">
												<div class="alert-option-content">
													<div class="alert-option-label">On-demand</div>
													<div class="alert-option-description-with-input">
														<span>Send when a machine is predicted to stock out within:</span>
														<span class="threshold-inline">
															<input
																type="number"
																[(ngModel)]="stockoutThreshold"
																(change)="onThresholdChange()"
																min="1"
																max="7"
																placeholder="7"
																class="threshold-input">
															<span class="threshold-unit">days</span>
														</span>
													</div>
												</div>
											</mat-radio-button>
										</div>
									</mat-radio-group>
								</div>

								<!-- Campus Selection -->
								<div class="config-section">
									<div class="config-label mb-2">Applies to: <span class="text-danger">*</span></div>

									<!-- Hierarchical Filters (Partner/Market/Client) -->
									<div class="hierarchical-filters-row">
										<kt-hierarchical-filters
											[role]="role"
											[showDistributor]="role === 'sadmin'"
											[showMarket]="role === 'sadmin' || role === 'distiadmin'"
											[showClient]="role === 'sadmin' || role === 'distiadmin' || role === 'marketadmin' || role === 'clientadmin'"
											[showCampus]="false"
											[multiple]="false"
											[disabled]="loadingCampuses || !stockoutSubscribed"
											(filterChange)="onHierarchicalFilterChange($event)">
										</kt-hierarchical-filters>
									</div>

									<!-- Campus Multi-Select - Styled like hierarchical filters but on second line -->
									<div class="campus-select-row">
										<div class="scope-select-wrapper">
											<label class="scope-select-label">Campus</label>
											<kt-searchable-select
												[options]="campusSelectOptions"
												placeholder="Select campuses..."
												searchPlaceholder="Search campuses..."
												[ngModel]="campusDropdownValue"
												(immediateSelectionChange)="onCampusImmediateSelect($event)"
												(selectionChange)="onCampusSelectChange($event)"
												[disabled]="loadingCampuses || !stockoutSubscribed"
												[multiple]="false"
												[clearOnSelect]="true"
												[displayValueFn]="getCampusDisplay">
											</kt-searchable-select>
										</div>

										<!-- Selected Campus Chips - Positioned to the right of dropdown -->
										<div *ngIf="selectedCampusIds.length > 0" class="campus-chips-container">
											<mat-chip-list>
												<mat-chip
													*ngFor="let campusId of selectedCampusIds"
													color="primary">
													{{ getCampusName(campusId) }}
													<mat-icon matChipRemove (click)="removeCampus(campusId); $event.stopPropagation()">cancel</mat-icon>
												</mat-chip>
											</mat-chip-list>
										</div>
									</div>

									<!-- Validation Hint -->
									<div *ngIf="stockoutSubscribed && selectedCampusIds.length === 0" class="mt-2">
										<span class="text-danger" style="font-size: 0.75rem;">At least one campus must be selected</span>
									</div>
									<div *ngIf="filteredCampuses.length === 0 && !loadingCampuses && stockoutSubscribed" class="mt-2">
										<span class="text-muted" style="font-size: 0.75rem;">No campuses available. Try adjusting the filters above.</span>
									</div>
								</div>
							</div>
						</div>

						<!-- Save Button -->
						<div class="row mt-4 mb-3">
							<button
								mat-raised-button
								color="accent"
								(click)="saveSubscriptions()"
								[disabled]="!hasChanges || loadingSubscriptions || (stockoutSubscribed && selectedCampusIds.length === 0)">
								Save
							</button>
						</div>
					</div>
				</div>
			</mat-tab>
			<!-- <mat-tab label="Reports">
				<div class="ml-3" style="min-height: 40vh;">
					<mat-checkbox class="mt-3 mb-3 col-xl-3 col-md-4 col-sm-6" (change)="sumRepClicked()" [(ngModel)]="summaryReport">Summary Report</mat-checkbox>
				</div>
			</mat-tab> -->
		</mat-tab-group>
	</div>
</div>
